import { env }       from '../utils/utils'
import * as internal from './internal'
import * as external from './external'

const authMode = env('AUTH_MODE')
const authentication = (authMode === 'external' ? external : internal)

const  { authLink, AuthProvider, tokenPromise, useCurrentUser, useAuthNavigation, useInternalLogin } = authentication
export { authMode, authLink, AuthProvider, tokenPromise, useCurrentUser, useAuthNavigation, useInternalLogin }
